"use strict";

import Flickity from 'vue-flickity';
import "flickity-imagesloaded"

Vue.component("bsnSlider", {
    components: {
        Flickity
    },
    props: [
        "items", "minItems"
    ],
    data() {
        return {
            eventSlider: {
                prevNextButtons: false,
                pageDots: false,
                imagesLoaded: true,
                // wrapAround: true,
                cellAlign: "left",
                autoPlay: 4000,
                pauseAutoPlayOnHover: true,
                percentPosition: true,
            },

            fullSlider: {
                prevNextButtons: false,
                pageDots: true,
                imagesLoaded: true,
                wrapAround: true,
                autoPlay: 4000,
                pauseAutoPlayOnHover: true,
                resize: true,
                draggable: ">1"
            },

            ticketSlider: {
                prevNextButtons: false,
                pageDots: true,
                imagesLoaded: true,
                wrapAround: true,
                //autoPlay: 4000,
                //pauseAutoPlayOnHover: true,
                resize: true
            },
            sliderTextDisplay: "none",
        }
    },
    methods: {
        next() {
            this.$refs.flickity.next();
        },

        previous() {
            this.$refs.flickity.previous();
        }
    },
    mounted: function () {
        this.$data.sliderTextDisplay = "block";
        if (this.items && this.minItems) {
            if (this.items <= this.minItems) {
                this.$refs.flickity.disableDrag();
                this.$refs.flickity.stopPlayer();
            }
        }
    }
});



// WEBPACK FOOTER //
// ./frontend/js/slider.js